import { useContext } from 'react';
import type { ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useFollowCourse } from '@openclassrooms/data-connect-web/learning-activity';
import { getPathName, ROUTES } from '@openclassrooms/routing';
import { scrollToElement } from '@openclassrooms/ui-web/scroll';

import CourseContext from '../../contexts/courseContext';
import COURSE_TABS from '../../constants/courseTabs';
import CategoryButton from '../CategoryButton';

export interface FollowCourseButtonProps {
  children: ReactNode;
}
function FollowCourseButton({ children }: FollowCourseButtonProps) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { course, currentUser, nextChapter, refetchCourseData } = useContext(CourseContext);
  const [, { isLoading, mutateAsync: followCourse }] = useFollowCourse();
  const { categoryColor, isSinglePage } = course;

  const handleFollowCourse = async () => {
    await followCourse(
      { courseId: course.id, userId: currentUser.id },
      {
        onSuccess: () => {
          refetchCourseData();

          if (isSinglePage) {
            scrollToElement(document.getElementById(COURSE_TABS.TAB_OVERVIEW), {
              offset: 0,
            });
          }
        },
      }
    );

    if (isSinglePage) return;

    const redirectPath = getPathName(
      ROUTES.COURSES.CHAPTERS,
      {
        courseIdSlug: `${course.id}-${course.slug}`,
        chapterIdSlug: `${nextChapter?.id}-${nextChapter?.slug}`,
      },
      false
    );

    navigate(redirectPath, {
      state: { from: pathname },
    });
  };

  return (
    <CategoryButton
      isLoading={isLoading}
      onClick={handleFollowCourse}
      categoryColor={categoryColor}
    >
      {children}
    </CategoryButton>
  );
}

export default FollowCourseButton;
